import React from "react";

const Modal = () => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="final-image"></div>
      </div>
    </div>
  );
};

export default Modal;
